<template>
  <section class="nosotros">
    <div class="nosotros__container">
      <div class="nosotros__info">
        <h3 class="nosotros__info-title">Nosotros</h3>
        <p class="nosotros__info-text">
          Somos una agencia digital versátil y resolutiva.
        </p>
        <p class="nosotros__info-text">
          Sabemos que los diferentes puntos de vista siempre suman al momento de
          desarrollar una idea, por eso trabajamos en sinergia para brindar
          soluciones rápidas, efectivas y de calidad a todas las necesidades
          habituales de las empresas. Esta química se ve reflejada en el éxito
          de los trabajos donde formamos parte.
        </p>
        <!-- <p class="nosotros__info-text">
          Nos convertimos en extensa familia de diferentes sectores geográficos
          con alta variedad cultural, lo que enriquece nuestra creatividad y le
          brinda color a nuestros proyectos.
        </p> -->
      </div>

      <div class="nosotros__image-container">

          <img class="nosotros__image"  src="/img/jpg/NOSOTROS_new.png"/>
      </div>
    </div>

    <!--     <div class="section__somos--info">
      <div class="section__somos--info--text">
        <h1
          @click="toggleInfo('SOMOS')"
          class="clickable"
          :class="{
            title: active === 'SOMOS',
            subtitle: active === 'FILOSOFÍA',
          }"
        >
          <span v-if="active === 'FILOSOFÍA'">>&nbsp;</span>NOSOTROS
        </h1>
        <transition name="unfold">
          <p class="paragraph" v-if="active === 'SOMOS'">
            Somos una agencia versátil con una dinámica y estructura poco usual,
            gracias a la que nos permitimos afrontar grandes desafíos
            comunicacionales. Nos mueve la pasión, por eso siempre alcanzamos y
            superamos las expectativas.
          </p>
        </transition>
        <h1
          @click="toggleInfo('FILOSOFÍA')"
          class="clickable"
          :class="{
            title: active === 'FILOSOFÍA',
            subtitle: active === 'SOMOS',
          }"
        >
          <span v-if="active === 'SOMOS'">>&nbsp;</span>FILOSOFÍA
        </h1>
        <transition name="unfold">
          <div class="accordion" v-if="active === 'FILOSOFÍA'">
            <div class="accordion__element" :style="accordionHeight(1)">
              <div class="accordion__header" @click="setActivePhilosophy(1)">
                <font-awesome-icon
                  :icon="['far', 'plus']"
                  size="lg"
                  class="accordion__header--icon"
                  v-if="activePhilosophy !== 1"
                />
                <font-awesome-icon
                  icon="minus"
                  size="lg"
                  class="accordion__header--icon"
                  v-if="activePhilosophy === 1"
                />
                <div class="accordion__header--title">
                  Varios puntos de vista
                </div>
              </div>
              <p class="paragraph">
                Nuestra característica principal es la interdisciplinariedad, ya
                que los diferentes puntos de vista son los que suman al momento
                de desarrollar una idea. Contamos con profesionales de diversas
                áreas trabajando en conjunto para brindar soluciones rápidas,
                efectivas y de calidad a todos los problemas habituales de las
                empresas.
              </p>
            </div>
            <div class="accordion__element" :style="accordionHeight(2)">
              <div class="accordion__header" @click="setActivePhilosophy(2)">
                <font-awesome-icon
                  :icon="['far', 'plus']"
                  size="lg"
                  class="accordion__header--icon"
                  v-if="activePhilosophy !== 2"
                />
                <font-awesome-icon
                  icon="minus"
                  size="lg"
                  class="accordion__header--icon"
                  v-if="activePhilosophy === 2"
                />
                <div class="accordion__header--title">
                  Capacidad de producción
                </div>
              </div>
              <p class="paragraph">
                Sea cual sea tu necesidad, podemos adaptarnos y generar
                comunicación de calidad.<br />La fábrica comunicacional es
                nuestro proceso de trabajo, un sistema que nos permite abordar
                problemáticas de diferentes índoles y correr maratones. No hay
                reto que no aceptemos, el motor de la productividad es la
                adrenalina del desafío.
              </p>
            </div>
            <div class="accordion__element" :style="accordionHeight(3)">
              <div class="accordion__header" @click="setActivePhilosophy(3)">
                <font-awesome-icon
                  :icon="['far', 'plus']"
                  size="lg"
                  class="accordion__header--icon"
                  v-if="activePhilosophy !== 3"
                />
                <font-awesome-icon
                  icon="minus"
                  size="lg"
                  class="accordion__header--icon"
                  v-if="activePhilosophy === 3"
                />
                <div class="accordion__header--title">
                  Del interior a la ciudad
                </div>
              </div>
              <p class="paragraph">
                Tenemos en nuestro ADN el espíritu del interior: la dedicación,
                la humildad y la fraternidad. Somos más que compañeros de
                trabajo, somos una familia de profesionales, de diferentes
                sectores geográficos y con una variedad cultural muy grande que
                enriquece nuestras ideas y le brinda color a nuestros proyectos.
              </p>
            </div>
          </div>
        </transition>
      </div>
      <div class="section__somos--info--photo" :style="usImg"></div>
    </div> -->
    <!-- <switcher up="heading" down="fabrica"></switcher> -->
  </section>
</template>
<script>
import mixins from '@/mixins/mixins'
// import switcher from '@/components/switcher'

export default {
  mounted () {
    this.$store.commit('setScrolling', false)
  },
  data () {
    return {
      active: 'SOMOS',
      activePhilosophy: 0
    }
  },
  methods: {
    toggleInfo (section) {
      this.activePhilosophy = 0
      this.active = section
      setTimeout(() => {
        this.setActivePhilosophy(1)
      }, 400)
    },
    setActivePhilosophy (count) {
      if (this.activePhilosophy === count) {
        this.activePhilosophy = 0
      } else {
        this.activePhilosophy = count
      }
    },
    accordionHeight (elem) {
      if (this.activePhilosophy === elem) {
        const accordion = document.querySelector('.accordion')
        const element = accordion.childNodes[elem - 1]
        const paragraph = element.childNodes[1]
        return `height: ${72 + paragraph.offsetHeight}px`
      }
      return 'height: 72px'
    }
  },
  computed: {
    toggleTitle () {
      if (this.active === 'SOMOS') {
        return 'FILOSOFÍA'
      }
      return 'SOMOS'
    },
    usImg () {
      if (this.active === 'SOMOS') {
        return `background-image: url('/img/jpg/NOSOTROS.jpg')`
      } else if (this.active === 'FILOSOFÍA') {
        return `background-image: url('/img/jpg/FILOSOFIA.jpg')`
      }
      return ''
    }
  },
  mixins: [mixins]
}
</script>
